import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/dinning.jpg";

import dining from "../assets/dinning.jpg";

import dinning1 from "../assets/dinning-1.jpg";
import dinning2 from "../assets/dinning-2.jpg";
import dinning3 from "../assets/dinning-3.jpeg";
import dinning4 from "../assets/dinning-4.jpeg";

function Dining() {

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    const [selectedImg, setSelectedImg] = useState(null);

    const images = [dinning1, dinning2, dinning3, dinning4];

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[60vh] w-full">
                <img
                    src={aboutHero}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        Dining
                    </h1>
                </div>
            </section>

            {/* ================= Dining SECTION ================= */}
            <section className="relative bg-white py-12 sm:py-12 lg:py-12 px-4 sm:px-6 lg:px-16">
                <div className="mx-auto max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                    {/* ===== Left Text Content ===== */}
                    <div data-aos="fade-left" className="flex justify-center">
                        <div data-aos="fade-right">

                            <h2 className="text-3xl md:text-4xl font-semibold mb-4">
                                Dining
                            </h2>

                            <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                                Savor local flavors & sunset dinners at Three Tree Villa by Habarana 🍴
                            </p>

                            <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                                Complimentary breakfast with hoppers, string hoppers, & more...
                            </p>

                            <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                                BBQ dinners by the pool (order in advance).
                            </p>

                            <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                                Sunset cocktails & snacks at the gazebo 🌅.
                            </p>

                            <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                                Local cuisine & seafood (custom orders welcome).
                            </p>

                            <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                                Packed lunches for nature trips.
                            </p>

                        </div>

                    </div>

                    {/* ===== Right Image ===== */}
                    <img
                        src={dining}
                        alt="Three Tree Villa by Habarana"
                        className="rounded-lg shadow-lg w-full max-w-[500px] h-[400px] sm:h-[500px] md:h-[500px] object-fixed"
                    />

                </div>
            </section>

            {/* ================= Our Villa SECTION ================= */}
            <section className="bg-white py-10 px-4 sm:px-6 lg:px-16">
                <div className="max-w-6xl mx-auto">

                    {/* Title */}
                    <div className="text-center mb-12">
                        <span className="block w-20 h-[2px] bg-orange-400 mx-auto mb-4"></span>
                        <h2
                            data-aos="fade-up"
                            className="text-3xl md:text-4xl font-semibold mb-4"
                        >
                            Our Villa
                        </h2>
                    </div>

                    {/* Image Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                        {images.map((img, index) => (
                            <div
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                                className="cursor-pointer"
                                onClick={() => setSelectedImg(img)}
                            >
                                <img
                                    src={img}
                                    alt={`Our Villa ${index + 1}`}
                                    className="rounded-lg shadow-lg w-full h-[280px] object-fixed transition-transform duration-500 hover:scale-105"
                                />
                            </div>
                        ))}
                    </div>

                </div>

                {/* Popup Modal */}
                {selectedImg && (
                    <div
                        className="fixed inset-0 bg-black/70 flex justify-center items-center z-50 p-4"
                        onClick={() => setSelectedImg(null)}
                    >
                        <div className="relative">
                            {/* Close Button */}
                            <button
                                onClick={() => setSelectedImg(null)}
                                className="absolute -top-4 -right-4 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold shadow-lg hover:bg-gray-200 transition z-50"
                            >
                                &times;
                            </button>

                            <img
                                src={selectedImg}
                                alt="Expanded"
                                onClick={(e) => e.stopPropagation()}
                                className="rounded-lg shadow-lg
                         w-full
                         max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl
                         max-h-[80vh] object-contain"
                            />
                        </div>
                    </div>
                )}
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default Dining;
